
---
**Note:** campaign sales are grouped on the day the campaign was sent.

Example: if the campaign was sent on 04/10, 7 attributed sales happened on the same day and 3 on the next day (04/11), the values for all 10 sales will be shown on the send date (04/10).
